import { Body1, Body2 } from '@cian/ui-kit';
import { IconActionFilters16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { MAINPAGE_SEARCH_URL } from 'shared/constants/constants';

import { useScrollCollapseFallback } from './useScrollCollapseFallback';

import * as styles from './RedesignMainpageSearchBox.css';

export interface IRedesignMainpageSearchBoxProps {
  filtersUrl: string;
  onSearchClick(event: React.MouseEvent<HTMLAnchorElement>): void;
  onFiltersClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
}

const EXPANDED_PLACEHOLDER = 'Что ищете?';
const COLLAPSED_PLACEHOLDER = 'Что ищете?';

export const RedesignMainpageSearchBox: React.FC<IRedesignMainpageSearchBoxProps> = ({
  filtersUrl,
  onSearchClick,
  onFiltersClick,
}) => {
  const rootRef = React.useRef<HTMLDivElement>(null);

  useScrollCollapseFallback(rootRef, styles['is-scrolled']);

  return (
    <div ref={rootRef} className={styles['search-box']} data-testid="RedesignMainpageSearchBox">
      <a href={MAINPAGE_SEARCH_URL} className={styles['search-field']} onClick={onSearchClick}>
        <span className={styles['placeholder-stack']}>
          <span className={styles['placeholder-expanded']}>
            <Body2 color="text-secondary-default">{EXPANDED_PLACEHOLDER}</Body2>
          </span>
          <span className={styles['placeholder-collapsed']} aria-hidden="true">
            <Body1 color="text-secondary-default">{COLLAPSED_PLACEHOLDER}</Body1>
          </span>
        </span>
      </a>
      <a
        href={filtersUrl}
        className={styles['filters-button']}
        onClick={onFiltersClick}
        data-testid="RedesignMainpageSearchBoxFiltersButton"
        aria-label="Фильтры"
      >
        <IconActionFilters16 />
      </a>
    </div>
  );
};

RedesignMainpageSearchBox.displayName = 'RedesignMainpageSearchBox';
